import _ from 'lodash';

export const mapNodes = (parentNode) => (acc, item) => {
  if (_.isNil(item)) {
    return;
  }

  item.parentNode = parentNode;
  const itemChildren = item.Children ? item.Children.reduce(mapNodes(item), {}) : [];

  return {
    ...acc,
    [item.Id]: item,
    ...itemChildren,
  };
};

export const getSelectedItemPath = (node) => {
  const path = [node];

  let parent = node.parentNode;

  while (parent !== undefined) {
    path.push(parent);
    parent = parent.parentNode;
  }

  return path.reverse();
};

export const isSelectable = (node, type) => {
  if (type === 'CDRH') {
    return !(_.isArray(node.Children) && node.Children.length > 0);
  }
  const isCodeLevelOne = !node.parentNode?.parentNode;
  // for Annex E and G level one codes are not valid for submission
  // for Annex A, B, C, D, F any level code may be selected
  return (
    (['A', 'B', 'C', 'D', 'F'].includes(node.TermHierarchy) || !isCodeLevelOne) && node.parentNode
  );
};

export const isShowWarningModal = (node) => {
  const idCodeLevelTwo = !node.parentNode?.parentNode?.parentNode;
  // for Annex A, B, C, D, F if user selects a code that has lower level codes, display a warning message
  const isShowWarningForABCDF =
    ['A', 'B', 'C', 'D', 'F'].includes(node.TermHierarchy) && node.ChildrenCount;
  // for Annex E and G if user select a level 2 code and a lower level code exits, display a warning message
  const isShowWarningForEG =
    ['E', 'G'].includes(node.TermHierarchy) && idCodeLevelTwo && node.ChildrenCount;

  return !!(isShowWarningForABCDF || isShowWarningForEG);
};

export const getLabel = (node, type) => {
  const { Code, Name, UDF1, UDF6 } = node;
  return type === 'IMDRF' ? `${Name} (${Code})` : `${Name} (${Code}), (${UDF1}), (${UDF6})`;
};

export const getAlphabetDisableSet = (nodeChildren) => {
  const set = new Set();

  for (const child of nodeChildren) {
    const { Name } = child;
    set.add(Name[0].toUpperCase());
  }

  return set;
};
